import DataSource from "../DataSource";
import RecordSource from "../DataSource/RecordSource";
import Resource from "../Resource";
import Record from "../Resource/Record";

export default class PracovnaDobaService {

  constructor(server){
    this.server = server;
  }

  getRecordSource(config = {}){
    return new RecordSource(new Resource(this.server, "PracovnaDoba"), this.server, "PracovnaDoba.list", config);
  }

}


// WEBPACK FOOTER //
// ./src/services/PracovnaDobaService.js